export const work = [
  {
    id: 1,
    title: 'YOUNG ENOUGH - "HumanVirus" (Official Music Video)',
    url: "https://www.youtube.com/embed/b-OYZ2c9tiE",
    text: ["Music video directed by alice j.", "DOP : alice j.", "Written by : alice j."],
    category: "music-video",
  },
  {
    id: 2,
    title: "Eslo x Fazé - Jamais (Clip Officiel)",
    url: "https://www.youtube.com/embed/6TQ9Rr1KS7Q",
    text: [
      "Music video directed by alice j.",
      "DOP : alice j.",
      "Written by : Eslo & Fazé",
    ],
    category: "music-video",
  },
  {
    id: 3,
    title: 'YOUNG ENOUGH - "I Want My K7s Back" (Official Music Video)',
    url: "https://www.youtube.com/embed/HI8Jphj-bsI",
    text: ["Music video directed by alice j.", "DOP : alice j."],
    category: "music-video",
  },
  {
    id: 4,
    title: "The Lucky Trolls - City Of Iron (Official Music Video)",
    url: "https://www.youtube.com/embed/lH6zRgVbZqU",
    text: [
      "Music video directed by alice j.",
      "DOP : alice j.",
      "Written by : The Lucky Trolls",
    ],
    category: "music-video",
  },
  {
    id: 5,
    title: 'YOUNG ENOUGH - "Minimum Wage" (Official Music Video)',
    url: "https://www.youtube.com/embed/MSmJXV4GCWI",
    text: [
      "Music video directed by alice j.",
      "DOP : alice j.",
      "Written by : alice j. & Young Enough",
    ],
    category: "music-video",
  },
  {
    id: 6,
    title: "MR.FARTFACE - LET IT SKATE (OFFICIAL VIDEO)",
    url: "https://www.youtube.com//embed/Uvkzl5baLIg",
    text: [
      "Music video directed by alice j.",
      "DOP : alice j.",
      "Written by : Mr.Fartface",
    ],
    category: "music-video",
  },
  {
    id: 7,
    title: "Pool Party Chicks - Leave Out Our Best Days",
    url: "https://www.youtube.com//embed/qDVmycxEU_4",
    text: [
      "Music video directed by alice j.",
      "DOP : alice j.",
      "Written by : alice j. & Pool Party Chicks",
    ],
    category: "music-video",
  },
  {
    id: 8,
    title: "Get Rid Of Myself (official video)",
    url: "https://www.youtube.com//embed/Y4CVCUxFpjQ",
    text: [
      "Music video directed by alice j.",
      "DOP : alice j.",
      "Written by : alice j. & Everlords",
    ],
    category: "music-video",
  },
  {
    id: 9,
    title: "Hidden Path - Untrust from Within (Official Music Video)",
    url: "https://www.youtube.com//embed/dijl7L68VHI",
    text: [
      "Music video directed by alice j.",
      "DOP : alice j.",
      "Written by : alice j. & Hidden Path",
    ],
    category: "music-video",
  },
  {
    id: 10,
    title: "Pool Party Chicks - Keep Waiting",
    url: "https://www.youtube.com/embed/qDJpzx0ApO8?si=usIMcrmZmh98Rr7V",
    text: [
      "Music video directed by alice j.",
      "DOP : alice j.",
      "Written by : alice j. & Pool Party Chicks",
    ],
    category: "music-video",
  },
  {
    id: 11,
    title: "YOUNG ENOUGH - 'Vanish' (Official Music Video)",
    url: "https://www.youtube.com//embed/eMXHZngDee0",
    text: [
      "Music video directed by alice j.",
      "DOP : alice j.",
      "Written by : Young Enough",
    ],
    category: "music-video",
  },
   {
    id: 12,
    title: "MR.FARTFACE - GUTS & NOISE (OFFICIAL VIDEO)",
    url: "https://www.youtube.com/embed/EQ2yu8gKxBA?si=BVSzPUqJm34Hahno",
    text: [
      "Music video directed by alice j.",
      "DOP : alice j.",
      "Written by : MR.FARTFACE",
    ],
    category: "music-video",
  },
   {
    id: 13,
    title: "MR.FARTFACE - MY WAY (OFFICIAL VIDEO)",
    url: "https://www.youtube.com/embed/hvHd-JqmmB0?si=WilJTIWR2UcBpfNe",
    text: [
      "Music video directed by alice j.",
      "DOP : alice j.",
      "Written by : MR.FARTFACE",
    ],
    category: "music-video",
  },
   {
    id: 14,
    title: "Pool Party Chicks - Never Better On Your Own (Official Music Video)",
    url: "https://www.youtube.com//embed/Mx68jAZnsak",
    text: [
      "Music video directed by alice j.",
      "DOP : alice j.",
    ],
    category: "music-video",
  },
  {
    id: 15,
    title: "SKND - Avalanche (Official music video)",
    url: "https://www.youtube.com//embed/glGx8mFezyo",
    text: [
      "Music video directed by alice j.",
      "DOP : alice j.",
    ],
    category: "music-video",
  },
  {
       id: 16,
    title: "Live show aftermovie w/ Ocean Encounters (2024)",
    url: "https://www.youtube.com/embed/d6ul1rMYD-8?si=8nHEY32agGR6oTiv",
    text: [
      "Aftermovie filmed & edited by alice j.",
    ],
    category: "aftermovie",
  },
  {
       id: 17,
    title: "Alcatraz Metal Festival '24 - final aftermovie",
    url: "https://www.youtube.com/embed/lq4S936gB54?si=ZS8iXKDK3fsua_dm",
    text: [
      "Aftermovie edited by alice j.",
      "Footage : Helmert Decavele (drone), Lucas Dewulf (360 pit), Matt Jarvis, Senne Krijnen, Reinout Roose",
    ],
    category: "aftermovie",
  },
  {
        id: 18,
    title: "Fiesta City '24 aftermovie w/ Olive",
    url: "https://www.youtube.com/embed/yKQgUMr2OEM?si=slY-kkpyjKslOe9D",
    text: [
      "Aftermovie filmed & edited by alice j.",
    ],
    category: "aftermovie",
  },
  {
    id: 19,
    title: "You Nervous? - Trapped Inside (Official music video)",
    url: "https://www.youtube.com/embed/p-8xAOyX5tU?si=vnIsy-W8lLzX-lu_",
    text: [
      "Music video directed by alice j.",
      "DOP : alice j.",
      "Written by : alice j. & You Nervous",
    ],
    category: "music-video",
  },
   {
    id: 20,
    title: "OLIVE - DÉPARTS ET ARRIVÉES (Clip Officiel)",
    url: "https://www.youtube.com/embed/AAyGI3klE5o?si=45S-fSwcylbSD53j",
    text: [
      "Music video directed by alice j.",
      "DOP : alice j.",
      "Written by : alice j. & OLIVE",
     ],
    category: "music-video",
   },
    {
    id: 21,
    title: "Festival La ReA 2025 - Panique au Bureau (capsule promo)",
    url: "https://www.youtube.com/embed/IzbaTf34msE?si=R_YOxQYhDiE5ENbX",
    text: [
      "Promo clip directed by Jean-Mathias Pondant",
      "DOP : alice j.",
      "Editing & colorgrading : alice j.",
      "Written by : Antonin Victor Seron",
     ],
    category: "promo",
   },
    {
    id: 22,
    title: "Basement Low End - Panic Scene (Official Video)",
    url: "https://www.youtube.com/embed/bEOOSaBS7dI?si=GlS3SE_z_pwuGFOt",
    text: [
      "Music video directed by Alice Jeanmart",
      "DOP : alice j.",
      "Lights : Denny Saladino",
      "Editing & colorgrading : alice j.",
     ],
    category: "music-video",
   },
    {
    id: 23,
    title: "Møïra - REMBOBINE",
    url: "https://www.youtube.com/embed/5mY1dZx8h0k?si=z3HTQpbcBbUmdr01",
    text: [
      "Music video directed by Alice Jeanmart",
      "DOP : alice j.",
      "Editing & colorgrading : alice j.",
     ],
    category: "music-video",
   },
   {
    id: 24,
    title: "Diluvian - LABYRINTH (Official Music Video)",
    url: "https://www.youtube.com/embed/3Sk3dbiOhnI?si=NyHXQMtJl7-QldAe",
    text: [
      "Music video directed by Alice Jeanmart",
      "DOP : alice j.",
      "Editing & colorgrading : alice j.",
     ],
    category: "music-video",
   },
   {
    id: 25,
    title: "OLIVE – DEHORS (Clip officiel)",
    url: "https://www.youtube.com/embed/hUNFPuGh5Rg?si=PW68AsAQ1YaA2Fhb",
    text: [
      "Music video directed by Alice Jeanmart",
      "DOP : alice j.",
      "Editing & colorgrading : alice j.",
     ],
    category: "music-video",
   },
 ]
